<!--
 * @Author: Gaho
 * @Date: 2024-12-13 17:53:26
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-26 19:44:09
 * @Description: 
-->
<template>
    <div
        class="flex w-full m-auto bg justify-center h-32 gap-2 absolute bottom-0 left-0 text-center items-end px-[10px]"
    >
        <div
            class="flex flex-1 justify-center max-w-[95px] items-center z-50 bg-grey-50 h-9 rounded-t-lg font-semibold"
            v-for="(v, k) in mutiplers"
            :key="k"
            :style="{
                borderBottom: `5px solid #${colors[k]}`,
                backgroundColor: mutipler === v && onceBet ? `#${colors[k]}` : '',
            }"
        >
            {{ v?.toFixed(2).slice(0, 4) }}x
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { ringConfig, colors } from '../data';
import { useJoinStateStore } from '~/stores/cansino/joinState';
import { fnGetRingConfig } from '@/pages/casino/ringGame/ts/ringGame';
import { oGameName2Api } from '~/common/js/gameAbout';
import { showTips4BadAmountIfNeeded } from '~/common/js/betHelper';
const { coefficients } = ringConfig;

const props = defineProps({
    segments: {
        type: Number,
        required: true,
    },
    risk: {
        type: String,
        required: true,
    },
    rotateNum: {
        type: Number,
        required: true,
    },
    onceBet: {
        type: Boolean,
        required: true,
    },
    amount:{
        type: [String, Number],
        required: false,
    }
});
const emit = defineEmits(['update:modelResult']);
const mutiplers=ref()

const fnSetAndCheckRingConfig = async ()=>{
    const {coefficients} = await fnGetRingConfig();
    mutiplers.value = coefficients[props.risk.toLowerCase()][props.segments];
    const maxValue = Math.max(...Object.values(mutiplers.value) as number[])
        // 调取当前最大赔付额提示
    const kenoMaxWin = Number(Number(props.amount).beFixed(2)) * Number(maxValue)
    showTips4BadAmountIfNeeded(kenoMaxWin);
    console.log(`${oGameName2Api.ringGame} 游戏配置`, );
}

if (import.meta.client){
    fnGetRingConfig();
}
const color = computed(() => {
    return ringConfig.weights[props.risk.toLowerCase()][props.segments].find(
        (v, i) => {
            if (i === props.rotateNum) {
                return v;
            }
        },
    );
});

const mutipler = computed(() => {
    const keys = Object.keys(coefficients[props.risk.toLowerCase()][props.segments]);
    const values = Object.values(
        coefficients[props.risk.toLowerCase()][props.segments],
    );
    const index = keys.indexOf(color.value);
    return values[index];
});

// 监听游戏难得变化
watch(() => props.risk, (newVal) => {
    if (import.meta.server) return;
    if (newVal){
        console.log('ring游戏难度监听：',newVal)
        // 难度变化更新结果展示
        emit('update:modelResult')
        fnSetAndCheckRingConfig();
    }
}, {
    deep: true,
    immediate: true
})
//监听游戏段变化
watch(() => props.segments, (newVal) => {
    if (import.meta.server) return;
    if (newVal){
        console.log('ring游戏段数监听：',newVal)
        // 段变化更新结果展示
        emit('update:modelResult')
        fnSetAndCheckRingConfig();
    }
}, {
    deep: true,
    immediate: true
})
//监听游戏金额
watch(() => props.amount, (newVal) => {
    if (import.meta.server) return;
    if (newVal){
        console.log('ring游戏金额：',newVal)
        fnSetAndCheckRingConfig();
    }
}, {
    deep: true,
    immediate: true
})
</script>

<style scoped lang="scss">
.bg {
    background: linear-gradient(180deg, rgba(0, 37, 93, 0), rgba(0, 24, 85, 0.72) 54.12%, #000c4e);
}
</style>
